var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.props.isOpened
    ? _c(
        "v-dialog",
        _vm._b(
          {
            attrs: {
              transition: _vm.transition,
              persistent: "",
              scrollable: "",
            },
            model: {
              value: _setup.props.isOpened,
              callback: function ($$v) {
                _vm.$set(_setup.props, "isOpened", $$v)
              },
              expression: "props.isOpened",
            },
          },
          "v-dialog",
          _setup.dialogProps,
          false
        ),
        [
          _c(
            "v-card",
            [
              _c(
                "header",
                { staticClass: "header" },
                [_c("v-card-title", [_vm._v(_vm._s(_setup.props.title))])],
                1
              ),
              _setup.props.subTitle
                ? _c("v-card-text", { staticClass: "sub-header" }, [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_setup.props.subTitle) },
                    }),
                  ])
                : _vm._e(),
              _c(
                "v-card-text",
                { staticClass: "card-text" },
                [
                  _vm._t("body", function () {
                    return [
                      _vm._t("prepend"),
                      _c(_setup.LfRequiredFieldsLegendComponent, {
                        attrs: {
                          showRequiredFieldsAdvice:
                            _setup.props.showRequiredFieldsAdvice,
                        },
                      }),
                      _c(_setup.FormGeneratorComponent, {
                        staticClass: "form-generator",
                        attrs: {
                          schema: _setup.props.formSchema,
                          fieldValues: _setup.props.formFieldValues,
                          context: _setup.props.context,
                          parentField: _setup.props.parentField,
                          formTag: "selectForm",
                        },
                        on: {
                          "execute-action": _setup.executeAction,
                          saveFormData: _setup.onSaveFormData,
                        },
                      }),
                    ]
                  }),
                ],
                2
              ),
              _setup.props.showActionButtons
                ? _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(_setup.LfActionsBarComponent, {
                        staticClass: "action-buttons",
                        attrs: {
                          buttons: _setup.buttons,
                          showKebabMenu: false,
                        },
                        on: { "execute-action": _setup.executeAction },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }